import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=a19a6ef2&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import style0 from "./Menu.vue?vue&type=style&index=0&id=a19a6ef2&prod&scoped=true&lang=css"
import style1 from "./Menu.vue?vue&type=style&index=1&id=a19a6ef2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19a6ef2",
  null
  
)

export default component.exports